import _ from "lodash";

import {
  RequestableSaasDestination,
  SaaSDestination,
  WarehouseDestination,
  warehouseDestinations,
} from "../destinations/destinations";
import { LoadedDestinationInfo, LoadedEventDefinition } from "../types/global";
import { DestinationDetail } from "./types";

export function getDestinationsForEvent(
  destinations: Array<LoadedDestinationInfo>,
  configurableDestinations: Record<
    string,
    | SaaSDestination
    | RequestableSaasDestination
    | WarehouseDestination
    | undefined
  >,
  event: LoadedEventDefinition,
): DestinationDetail[] {
  if (_.isEmpty(_.keys(destinations))) {
    return [];
  }

  return destinations
    .filter((dest) => {
      return isDestinationEnabledForEvent(dest, dest.type_slug, event);
    })
    .map((dest) => {
      const destination = configurableDestinations[
        dest.type_slug
      ] as SaaSDestination;

      let name = destination?.name;
      if (destination?.supportsMultiConfig) {
        name += ` | ${destination?.multiConfigLabel}: ${dest?.instance_name}`;
      }

      return {
        id: dest.id,
        name: name,
        Icon: destination?.logoSquare,
      };
    });
}

// Segment’s behavior: as soon as you track an event, it’s sent to all
// destinations by default. Freshpaint relies on this behavior for the GTM
// integration as there’s no configuration needed in the UI when you migrate
// from GTM
// Events that are NOT segment events are toggleable
// Segment events that are Warehouses are toggleable
// Segment events that are NOT warehouses are NOT toggleable
export function isDestinationToggleable(
  event: LoadedEventDefinition,
  isWarehouse: boolean,
) {
  const segmentWarehouse = event.segment_compatible && isWarehouse;
  const nonSegment = !event.segment_compatible;
  return nonSegment || segmentWarehouse;
}

export function isDestinationEnabledForEvent(
  destination: LoadedDestinationInfo,
  destinationSlug: string,
  event: LoadedEventDefinition,
) {
  return (
    event?.enabled_dests[destination.id] ||
    (event?.segment_compatible && !warehouseDestinations[destinationSlug])
  );
}

export function hasDuplicateEventNameAndSource(
  newEventDef: Pick<LoadedEventDefinition, "id" | "name" | "source">,
  existingEvents: Array<Pick<LoadedEventDefinition, "id" | "name" | "source">>,
): boolean {
  return existingEvents.some(
    (otherEventDef) =>
      otherEventDef.name === newEventDef.name &&
      otherEventDef.source === newEventDef.source &&
      otherEventDef.id !== newEventDef.id,
  );
}
